import assetPath from '/app/packages/login/layout/src/background-layout/images/energizer.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')